// UI
import { Heading } from "@/components/Typography"

// Translate
import { useTrans } from "@/lib/i18n"

/**
 * VoucherInstructions
 * @returns
 */
export function VoucherInstructions() {
	const t = useTrans("investor")

	return (
		<div>
			<Heading as="h5" className="mb-3 sm:truncate">
				{t("investor.community.invites.instructions.heading")}
			</Heading>
			{t("investor.community.invites.instructions.intro")}
			<ol className="ml-4 mt-4 list-decimal">
				<li>{t("investor.community.invites.instructions.step1")}</li>
				<li>{t("investor.community.invites.instructions.step2")}</li>
				<li>{t("investor.community.invites.instructions.step3")}</li>
			</ol>
		</div>
	)
}
